import { CreatePatientDto } from '@/core/models/patient.model'

type Options = { isSA: boolean; language?: string; now?: Date }

const randomDigits = (length: number) => Math.random().toString().substring(2, 2 + length).padEnd(length, '0')

/**
 * The emergency placeholder patient created by the "Emergency patient" buttons: inactive, agreement
 * "Emergency", identity to complete later (timestamp first name, "Urgence" / "Emergency" last name).
 */
export function buildEmergencyPatientDto({ isSA, language, now = new Date() }: Options): CreatePatientDto {
  return {
    agreement: 'Emergency',
    userInfo: {
      birthday: now.toISOString(),
      gender: 'I',
      name: now.toLocaleString().replace(/[/+:,\s]+/g, ''),
      surname: isSA ? 'Emergency' : 'Urgence',
    },
    active: false,
    // secu is required: 16 digits when the user works in Italian, 15 otherwise
    secu: randomDigits(language === 'it' ? 16 : 15),
  }
}
